import Popper from '@material-ui/core/Popper';
import * as React from 'react';

const CustomPopper = ({ children, ...rest }) => {
    return <Popper {...rest}>{children}</Popper>;
};

export { CustomPopper as Popper };
